var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{attrs:{"id":_vm.elementId,"items":_vm.years,"attach":_vm.attachId,"loading":_vm.loading,"readonly":_vm.readonly,"placeholder":'select'},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})
}
var staticRenderFns = []

export { render, staticRenderFns }